/* eslint-disable no-undef */
export const MonetixPagamigos = require("./MonetixPagamigos.webp");
export const Crypto = require("./Crypto.png");
export const MarsCrypto = require("./MarsCrypto.png");
export const Neteller = require("./Neteller.png");
export const OXXO = require("./OXXO.png");
export const SPEI = require("./SPEI.png");
export const MonetixVenezuelaBankTransfer = require("./MonetixVenezuelaBankTransfer.webp");
export const MonetixYape = require("./MonetixYape.webp");
export const MonetixPanamaCash = require("./MonetixPanamaCash.webp");
export const MonetixCoDi = require("./MonetixCoDi.webp");
export const MonetixDeunaQR = require("./MonetixDeunaQR.webp");
export const MonetixBoliviaBankTransfer = require("./MonetixBoliviaBankTransfer.webp");
export const MonetixBrazilCard = require("./MonetixPagamigos.webp");
export const MonetixBrazilCash = require("./MonetixPagamigos.webp");
export const MonetixBinancePay = require("./MonetixBinancePay.png");
export const MonetixArgentinaBankTransfer = require("./MonetixArgentinaBankTransfer.png");
export const MonetixBoleto = require("./MonetixBoleto.png");
export const MonetixChileBankTransfer = require("./MonetixChileBankTransfer.png");
export const MonetixChileCashTransfer = require("./MonetixChileCashTransfer.png");
export const MonetixColumbiaBankTransfer = require("./MonetixColumbiaBankTransfer.png");
export const MonetixCostaRicaCash = require("./MonetixCostaRicaBankTransfer.png");
export const MonetixCostaRicaBankTransfer = require("./MonetixCostaRicaBankTransfer.png");
export const MonetixThailandBank = require("./MonetixThailandBank.png");
export const MonetixPromptpay = require("./MonetixPromptpay.png");
export const MonetixRussiaP2PTransfer = require("./RussiaP2PTransfer.svg");
export const MonetixRussiaP2PTransferByCard = require("./RussiaP2PTransferByCard.svg");
export const MonetixRussiaP2PTransferByPhone = require("./RussiaP2PTransferByPhone.svg");
export const MonetixRussiaP2PTransferBySber = require("./RussiaP2PTransferBySber.svg");
export const MonetixRussiaP2PTransferByTbank = require("./RussiaP2PTransferByTbank.svg");
export const MonetixRussiaP2PTransferByAbroadPhone = require("./RussiaP2PTransferByAbroadPhone.svg");
export const MonetixRussiaP2PTransferByAbroadCard = require("./RussiaP2PTransferByAbroadCard.svg");
export const MonetixCrypto = require("./MonetixCrypto.png");
export const MonetixEcuadorBankTransfer = require("./MonetixEcuadorBankTransfer.png");
export const MonetixEcuadorCashTransfer = require("./MonetixEcuadorCashTransfer.png");
export const MonetixEfecty = require("./MonetixEfecty.png");
export const MonetixElSalvadorCashTransfer = require("./MonetixElSalvadorCashTransfer.png");
export const MonetixMexicoBankTransfer = require("./MonetixMexicoBankTransfer.png");
export const MonetixNequi = require("./MonetixNequi.png");
export const MonetixPSE = require("./MonetixPSE.png");
export const MonetixPagoEfectivo = require("./MonetixPagoEfectivo.png");
export const MonetixPeruBankTransfer = require("./MonetixPeruBankTransfer.png");
export const MonetixPeruCashTransfer = require("./MonetixPeruCashTransfer.png");
export const MonetixPix = require("./MonetixPix.png");
export const MonetixSpei = require("./MonetixSpei.png");
export const MonetixOxxo = require("./MonetixOxxo.png");
export const MonetixCard = require("./SpeiCard.png");
export const MonetixPicPay = require("./SPEI.png");
export const MonetixWebpayChile = require("./MonetixWebpayChile.png");
export const MonetixApplePayUK = require("./MonetixApplePayUK.png");
export const MonetixOpenBankingEU = require("./MonetixOpenBankingEU.png");
export const MonetixSepa = require("./MonetixSepa.svg");
export const MonetixFasterPayments = require("./MonetixFasterPayments.png");
export const MonetixCardOut = require("./MonetixCardOut.png");
export const STP =
	window.DEFAULT_LANG === "es" ? require("./MarsMxSTP.webp") : require("./stp.png");
export const anindamft = require("./anindamft.png");
export const anindacreditcard = require("./AnindaKrediKartiLight.svg");
export const atmkartsizEn = require("./atmkartsiz-en.png");
export const atmkartsizTr = require("./atmkartsiz-tr.png");
export const banktransfer = require("./banktransfer.png");
export const canlidestekparayatirEn = require("./canlidestekparayatir-en.png");
export const canlidestekparayatirTr = require("./canlidestekparayatir-tr.png");
export const cepbank = require("./cepbank.png");

export const cryBtc =
	window.DEFAULT_LANG === "es" && window.TENANT === "mars"
		? require("./MarsMxCryptopaymentBTC.webp")
		: window.TENANT === "chokwin"
			? require("./ChokwinBTC.webp")
			: window.TENANT === "mars" && window.DEFAULT_LANG !== "es"
				? require("./MarsBTC.webp")
				: window.TENANT === "luckykingbet"
					? require("./LuckyKingBetBTC.png")
					: window.TENANT === "gannar"
						? require("./GannarBTC.png")
						: require("./zenginsin-cry-btc.png");
export const cryEth =
	window.DEFAULT_LANG === "es" && window.TENANT === "mars"
		? require("./MarsMxCryptopaymentETH.webp")
		: window.TENANT === "chokwin"
			? require("./ChokwinETH.webp")
			: window.TENANT === "mars" && window.DEFAULT_LANG !== "es"
				? require("./MarsETH.webp")
				: window.TENANT === "luckykingbet"
					? require("./LuckyKingBetETH.png")
					: window.TENANT === "gannar"
						? require("./GannarETH.png")
						: require("./zenginsin-cry-eth.png");
export const cryTron =
	window.DEFAULT_LANG === "es" && window.TENANT === "mars"
		? require("./MarsMxCryptopaymentTRON.webp")
		: window.TENANT === "chokwin"
			? require("./ChokwinTRON.webp")
			: window.TENANT === "mars" && window.DEFAULT_LANG !== "es"
				? require("./MarsTRON.webp")
				: window.TENANT === "luckykingbet"
					? require("./LuckyKingBetTRON.png")
					: window.TENANT === "gannar"
						? require("./GannarTRON.png")
						: require("./zenginsin-cry-tron.png");
export const cryUsdt =
	window.DEFAULT_LANG === "es" && window.TENANT === "mars"
		? require("./MarsMxCryptopaymentUSDT.webp")
		: window.TENANT === "chokwin"
			? require("./ChokwinUSDT.webp")
			: window.TENANT === "mars" && window.DEFAULT_LANG !== "es"
				? require("./MarsUSDT.webp")
				: window.TENANT === "luckykingbet"
					? require("./LuckyKingBetUSDT.png")
					: window.TENANT === "gannar"
						? require("./GannarUSDT.png")
						: require("./zenginsin-cry-usdt.png");
export const cryptopay = require("./cryptopay.png");
export const fxcuzdan = require("./fxcuzdan.png");
export const hizliQr = require("./hizli-qr.png");
export const ixirpay = require("./ixirpay.png");
export const kkEn = require("./kk-en.png");
export const kkTr = require("./kk-tr.png");
export const kkhizliEn = require("./kkhizli-en.png");
export const kkhizliTr = require("./kkhizli-tr.png");
export const mft = require("./mft.png");
export const minihavale = require("./minihavale.png");
export const movenpayPapara = require("./movenpayPapara.svg");
export const odebitir = require("./odebitir.png");
export const papara = require("./papara.png");
export const paparafastEn = require("./paparafast-en.png");
export const paparafastTr = require("./paparafast-tr.png");
export const paparazzi = require("./paparazzi.png");
export const paybol = require("./paybol.png");
export const payco = require("./payco.png");
export const payfix = require("./payfix.png");
export const APayPIX = require("./MonetixPix.png");
export const pcodeEn = require("./pcode-en.png");
export const pcodeTr = require("./pcode-tr.png");
export const penapay = require("./penapay.png");
export const pep = require("./pep.png");
export const picPay = require("./picPay.png");
export const qr = require("./qr.png");
export const sapphirepapara = require("./sapphirepapara.png");
export const sendtofriendEn = require("./sendtofriend-en.png");
export const sendtofriendTr = require("./sendtofriend-tr.png");
export const trend = require("./trend.png");
export const trendKK = require("./trendKK.png");
export const turbohavale = require("./turbohavale.png");
export const vevopay = require("./vevopay.png");
export const vevopayPopyPara = require("./vevopayPopyPara.webp");
export const CoinsPaidADA = require("./CoinsPaidADA.webp");
export const CoinsPaid = require("./CoinsPaid.png");
export const CoinsPaidBCH = require("./CoinsPaidBCH.webp");
export const CoinsPaidBNB = require("./CoinsPaidBNB.webp");
export const CoinsPaidBTC = require("./CoinsPaidBTC.webp");
export const CoinsPaidDOGE = require("./CoinsPaidDOGE.webp");
export const CoinsPaidETH = require("./CoinsPaidETH.webp");
export const CoinsPaidLTC = require("./CoinsPaidLTC.webp");
export const CoinsPaidTRX = require("./CoinsPaidTRX.webp");
export const CoinsPaidUSDC = require("./CoinsPaidUSDC.webp");
export const CoinsPaidUSDTB = require("./CoinsPaidUSDTB.webp");
export const CoinsPaidUSDTE = require("./CoinsPaidUSDTE.webp");
export const CoinsPaidUSDTT = require("./CoinsPaidUSDTT.webp");
export const CoinsPaidXRP = require("./CoinsPaidXRP.webp");
export const BetterBroPicPay = require("./BetterBroPicPay.svg");
export const MarsCryptopaymentBTC = require("./MarsCryptopaymentBTC.webp");
export const MarsCryptopaymentETH = require("./MarsCryptopaymentETH.webp");
export const MarsCryptopaymentTRON = require("./MarsCryptopaymentTRON.webp");
export const MarsCryptopaymentUSDT = require("./MarsCryptopaymentUSDT.webp");
export const BetterBroSPEI = require("./BetterBroSPEI.png");
export const BetterBroOpenBanking = require("./BetterBroOpenBanking.webp");
export const BetterBroOXXO = require("./BetterBroOxxo.png");
export const BetterBroChileBankTransfer = require("./BetterBroChileBankTransfer.png");
export const BetterBroChileKhipuHPP = require("./BetterBroChileKhipuHPP.png");
export const BetterBroChileMachHPP = require("./BetterBroChileMachHPP.png");
export const BetterBroVenezuelaPagoMovilHPP = require("./BetterBroVenezuelaPagoMovilHPP.png");
export const BetterBroChileBancoEstadoBankTransfer = require("./BetterBroChileBancoEstadoBankTransfer.png");
export const BetterBroChileBancoSantanderBankTransfer = require("./BetterBroChileBancoSantanderBankTransfer.png");
export const BetterBroChileBancodeChileBankTransfer = require("./BetterBroChileBancodeChileBankTransfer.png");
export const BetterBroChileWebPay = require("./BetterBroChileWebPay.png");
export const BetterBroArgentinaTransferencia = require("./BetterBroArgentinaTransferencia.png");
export const BetterBroArgentinaMercadoPago = require("./BetterBroArgentinaMercadoPago.png");
export const BetterBroArgentinaNaranjaX = require("./BetterBroArgentinaNaranjaX.png");
export const BetterBroArgentinaMODO = require("./BetterBroArgentinaMODO.png");
export const BetterBroArgentinaBNA = require("./BetterBroArgentinaBNA.png");
export const BetterBroArgentinaCbuCvu = require("./BetterBroArgentinaCbuCvu.png");
export const APayDeposit = require("./APayDeposit.webp");
export const APaySPEI = require("./BetterBroOpenBanking.svg");
export const APayMpesa = require("./APayMpesa.png");
export const APayBankAlFalah = require("./APayBankAlFalah.png");
export const Vcreditos = require("./Vcreditos.webp");
export const APayImps = require("./APayImps.png");
export const APayBkash_a = require("./APayBkash_a.png");
export const APayBkash_b = require("./APayBkash_b.png");
export const APayNagadA = require("./APayNagadA.png");
export const APayNagadB = require("./APayNagadB.png");
export const APayJazzCash = require("./APayJazzCash.png");
export const DeltaPay = require("./APayJazzCash.png");
export const BankCard = require("./BankCard.png");
export const UnlimitBankCard = require("./UnlimitBankCard.png");
export const UnlimitBancomer = require("./UnlimitBancomer.png");
export const UnlimitPayPal = require("./UnlimitPayPal.png");
export const UnlimitBoleto = require("./UnlimitBoleto.png");
export const UnlimitOXXO = require("./UnlimitOXXO.png");
export const UnlimitSPEI = require("./UnlimitSPEI.png");
export const UnlimitPIX = require("./UnlimitPIX.png");
export const UnlimitQRCodePicPay = require("./UnlimitQRCodePicPay.png");
export const UnlimitCodi = require("./UnlimitCodi.png");
export const UnlimitSoriana = require("./UnlimitSoriana.png");
export const UnlimitWalmart = require("./UnlimitWalmart.png");
export const UnlimitBodegaAurrera = require("./UnlimitBodegaAurrera.png");
export const UnlimitSamsClub = require("./UnlimitSamsClub.png");
export const UnlimitCalimax = require("./UnlimitCalimax.png");
export const UnlimitTiendasExtra = require("./UnlimitTiendasExtra.png");
export const UnlimitCirculoK = require("./UnlimitCirculoK.png");
export const Unlimit7Eleven = require("./Unlimit7Eleven.png");
export const UnlimitTelecomm = require("./UnlimitTelecomm.png");
export const UnlimitBanorte = require("./UnlimitBanorte.png");
export const UnlimitFarmaciasBenavides = require("./UnlimitFarmaciasBenavides.png");
export const UnlimitFarmaciasDelAhorro =
	window.DEFAULT_LANG === "es" && window.TENANT === "mars"
		? require("./MarsMxUnlimitFarmaciasDelAhorro.webp")
		: require("./UnlimitFarmaciasDelAhorro.png");
export const UnlimitWaldos = require("./UnlimitWaldos.png");
export const UnlimitKiosko = require("./UnlimitKiosko.png");
export const UnlimitFarmaciasSantaMaria = require("./UnlimitFarmaciasSantaMaria.png");
export const UnlimitFarmaciasRoma = require("./UnlimitFarmaciasRoma.png");
export const UnlimitMerza = require("./UnlimitMerza.png");
export const UnlimitPayCash = require("./UnlimitPayCash.png");
export const UnlimitPaynet = require("./UnlimitPaynet.png");

// export const SkrillDigitalWallet = require("./SkrillDigitalWallet.svg");
// export const SkrillNeteller = require("./SkrillNeteller.svg");
// export const SkrillPaysafecard = require("./SkrillPaysafecard.svg");
// export const SkrillPaysafecash = require("./SkrillPaysafecash.svg");
// export const SkrillPagoEfectivo = require("./SkrillPagoEfectivo.svg");
// export const SkrillCreditCard = require("./SkrillCreditCard.svg");
// export const SkrillBlik = require("./SkrillBlik.svg");
// export const SkrillRapidTransfer = require("./SkrillRapidTransfer.svg");
// export const SkrillGiropay = require("./SkrillGiropay.svg");
// export const SkrillDirectDebit = require("./SkrillDirectDebit.svg");
// export const SkrillSofort = require("./SkrillSofort.svg");
// export const SkrillIdeal = require("./SkrillIdeal.svg");
// export const SkrillPoli = require("./SkrillPoli.svg");
// export const SkrillPrzelewy24 = require("./SkrillPrzelewy24.svg");
// export const SkrillEPay = require("./SkrillEPay.svg");
// export const SkrillTrustly = require("./SkrillTrustly.svg");
// export const SkrillAlipay = require("./SkrillAlipay.svg");
// export const SkrillAstroPayOnline = require("./SkrillAstroPayOnline.svg");
// export const SkrillAstroPayOffline = require("./SkrillAstroPayOffline.svg");
// export const SkrillAstroPayCash = require("./SkrillAstroPayCash.svg");
// export const SkrillRapyd = require("./SkrillRapyd.svg");
// export const SkrillCash = require("./SkrillCash.svg");
// export const SkrillOnlineBank = require("./SkrillOnlineBank.svg");
// export const SkrillPix = require("./SkrillPix.svg");
// export const SkrillMach = require("./SkrillMach.svg");
// export const SkrillBoleto = require("./SkrillBoleto.svg");
// export const SkrillMbWay = require("./SkrillMbWay.svg");
// export const SkrillMultibanco = require("./SkrillMultibanco.svg");
export const SkrillDigitalWallet = require("./SkrillDigitalWallet.png");
export const SkrillNeteller = require("./SkrillNeteller.png");
export const SkrillPaysafecard = require("./SkrillBlik.svg");
export const SkrillPaysafecash = require("./SkrillBlik.svg");
export const SkrillPagoEfectivo = require("./SkrillBlik.svg");
export const SkrillCreditCard = require("./SkrillBlik.svg");
export const SkrillBlik = require("./SkrillBlik.svg");
export const SkrillRapidTransfer = require("./SkrillBlik.svg");
export const SkrillGiropay = require("./SkrillBlik.svg");
export const SkrillDirectDebit = require("./SkrillBlik.svg");
export const SkrillSofort = require("./SkrillBlik.svg");
export const SkrillIdeal = require("./SkrillBlik.svg");
export const SkrillPoli = require("./SkrillBlik.svg");
export const SkrillPrzelewy24 = require("./SkrillBlik.svg");
export const SkrillEPay = require("./SkrillBlik.svg");
export const SkrillTrustly = require("./SkrillBlik.svg");
export const SkrillAlipay = require("./SkrillBlik.svg");
export const SkrillAstroPayOnline = require("./SkrillBlik.svg");
export const SkrillAstroPayOffline = require("./SkrillBlik.svg");
export const SkrillAstroPayCash = require("./SkrillBlik.svg");
export const SkrillRapyd = require("./SkrillBlik.svg");
export const SkrillCash = require("./SkrillBlik.svg");
export const SkrillOnlineBank = require("./SkrillBlik.svg");
export const SkrillPix = require("./SkrillBlik.svg");
export const SkrillMach = require("./SkrillBlik.svg");
export const SkrillBoleto = require("./SkrillBlik.svg");
export const SkrillMbWay = require("./SkrillBlik.svg");
export const SkrillMultibanco = require("./SkrillBlik.svg");
export const BetterBroPix = require("./BetterBroPix.svg");
export const Piastrix = require("./Piastrix.svg");
export const NuveiSTP = require("./SpeiCard.png");
export const NuveiSpei = require("./NuveiSpei.png");
export const NuveiPayCash = require("./NuveiPayCash.png");
export const NuveiCreditCard = require("./NuveiCreditCard.png");
export const GannarCrypto = require("./GannarCrypto.png");
export const GannarBankTransfer = require("./GannarBankTransfer.png");
